import { Box } from '@mui/material';

export function ShopFooterWidget() {
    return <Box sx={{ textAlign: 'center' }}>2024 Cool Story Project</Box>;
}
